import { Container, Row, Col } from "react-bootstrap";
import { FiMail, FiPhone, FiMessageCircle } from "react-icons/fi";

function Footer() {
  return (
    <footer className="footer-shell mt-5">
      <Container>
        <Row className="g-4">
          <Col md={4}>
            <h5 className="fw-bold text-white">CodeCamp</h5>
            <p className="text-light opacity-75">
              We build digital tools that help African businesses grow faster,
              work smarter, and serve customers better.
            </p>
          </Col>
          <Col md={2}>
            <h6 className="fw-semibold mb-3">Quick Links</h6>
            <a href="/services" className="footer-link">
              Services
            </a>
            <a href="/solutions" className="footer-link">
              Solutions
            </a>
            <a href="/portfolio" className="footer-link">
              Portfolio
            </a>
            <a href="/about" className="footer-link">
              About
            </a>
          </Col>
          <Col md={3}>
            <h6 className="fw-semibold mb-3">Contact</h6>
            <a href="mailto:contact@codecamp.ng" className="footer-link">
              <FiMail className="me-2" /> contact@codecamp.ng
            </a>
            <a href="tel:+2348077857683" className="footer-link">
              <FiPhone className="me-2" /> +234 807 785 7683
            </a>
            <a
              href="https://wa.me/2348077857683"
              className="footer-link"
              target="_blank"
              rel="noreferrer"
            >
              <FiMessageCircle className="me-2" /> WhatsApp
            </a>
          </Col>
          <Col md={3}>
            <h6 className="fw-semibold mb-3">Start a conversation</h6>
            <p className="text-light opacity-75">
              Tell us what is slowing your business down and we will shape the
              right solution.
            </p>
          </Col>
        </Row>
        <div className="border-top border-secondary mt-4 pt-3 text-light opacity-70 small">
          © 2026 CodeCamp Technologies. Built for growth.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
